import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import Iframe from 'react-iframe'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import CardActions from '@material-ui/core/CardActions';
import ChatBoxMoreInfo from './ChatBoxMoreInfo'
import PropTypes from 'prop-types';
import { setTimeout } from 'timers';

const styles = {
 
    root: {
        width: '100%',
        // minWidth: '150px',
        // height: '500px',
        // minHeight: '350px',
        align: 'center',
        //overflowX: 'auto',
        //display: 'column',
        alignItem: 'center',
        // margin: '0 Auto',
    },
    formControl: {
        // margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        // margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        justifyContent: 'center',
        // margin: '0 Auto',
    },
    InputLabel:{
        fontSize: '14px',
    },
    rightInput:{
        marginLeft: '50px',
    },
    country:{
        marginTop: '15px',
        marginBottom: '10px',
    },
    hkidPassport:{
        marginTop: '15px',
        marginBottom: '10px',
    },
  };

class AdminAcceptRejectBox extends Component {

    state = {
        status:'waiting',
        moreinfo:false,
      };

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    }
    
    submitHandler = (status) => {
        console.log('the status : '+JSON.stringify(status)+' | '+(status === 'moreinfo') )
        if (status === 'moreinfo'){
            this.setState({
                moreinfo: true
            })
        }
        else{
            this.props.AdminAcceptReject(this.props.caseId, status);
        }
    };

    render(){
        
        const { classes } = this.props; 

        return(
                // <form className={classes.root} >
                <div>
                    <Card className={classes.card}>
                        <CardContent>
                        <FormControl className={classes.margin} required fullWidth>
                        <label style={{ fontSize: '14px'}} >{this.context.t('Does the admin accept or reject this case or require more information?')}</label>
                        </FormControl>
                        </CardContent>
                        <CardActions>
                            {
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    value = "true"
                                    className={classes.button}
                                    onClick={() => { this.submitHandler('true') }}
                                >
                                    Accept
                                </Button>
                            }
                            {
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.button}
                                    value = "false"
                                    onClick={() => { this.submitHandler('false') }}
                                >
                                    Reject
                                </Button>
                            }
                            {
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.button}
                                    value = "moreInfo"
                                    onClick={() => { this.submitHandler('moreinfo') }}
                                >
                                    Require more information
                                </Button>
                            }
                           
                        </CardActions>                
                    </Card>
                    {this.state.moreinfo && <div>
                        <ChatBoxMoreInfo />
                    </div>}
                    </div>
                // </form>
        );
    }
}

// export default withStyles(styles)(ArbitratorAcceptRejectBox);
const mapStateToProps = (state) => {
    return {
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        AdminAcceptReject: (caseId, status) => dispatch(actions.AdminAcceptReject(caseId, status)),
    }
}

AdminAcceptRejectBox.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(AdminAcceptRejectBox)));